import { useEffect, useState } from "react";
import { Plus, Trash2, Megaphone } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { fecha } from "@/lib/format";
import { Loading, PageTitle } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function AdminAnuncios() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ titulo: "", cuerpo: "", categoria: "circular", autor: "Dirección" });

  const cargar = () => api.get("/anuncios").then((r) => setRows(r.data));
  useEffect(() => { cargar(); }, []);

  const crear = async () => {
    try {
      await api.post("/anuncios", form);
      toast.success("Anuncio publicado");
      setOpen(false);
      cargar();
    } catch (e) { toast.error(apiError(e)); }
  };

  if (!rows) return <Loading />;

  return (
    <div data-testid="admin-anuncios">
      <PageTitle title="Anuncios y circulares"
                 subtitle="Publicaciones visibles en el feed del portal de padres y tutores.">
        <Button className="rounded-full" onClick={() => setOpen(true)} data-testid="nuevo-anuncio">
          <Plus className="mr-2 h-4 w-4" /> Publicar
        </Button>
      </PageTitle>

      <div className="space-y-4" data-testid="lista-anuncios">
        {rows.map((a) => (
          <article key={a.id} className="lift rounded-lg border border-border/60 bg-card p-6 sm:p-8">
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-center gap-3">
                <Megaphone className="h-4 w-4 text-accent" />
                <h3 className="font-display text-lg font-semibold">{a.titulo}</h3>
                <Badge variant="outline" className="uppercase text-[10px] tracking-widest">{a.categoria}</Badge>
              </div>
              <Button size="icon" variant="ghost"
                      onClick={async () => { await api.delete(`/anuncios/${a.id}`); cargar(); }}
                      data-testid={`eliminar-anuncio-${a.id}`}>
                <Trash2 className="h-4 w-4 text-destructive" />
              </Button>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{a.cuerpo}</p>
            <p className="mt-3 text-xs text-muted-foreground/70">{fecha(a.creado_en)} · {a.autor}</p>
          </article>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="modal-anuncio">
          <DialogHeader><DialogTitle className="font-display">Nuevo anuncio</DialogTitle></DialogHeader>
          <div className="grid gap-4">
            <div className="space-y-2">
              <Label>Título</Label>
              <Input value={form.titulo} onChange={(e) => setForm({ ...form, titulo: e.target.value })}
                     data-testid="anuncio-titulo" />
            </div>
            <div className="space-y-2">
              <Label>Cuerpo</Label>
              <Textarea rows={5} value={form.cuerpo} onChange={(e) => setForm({ ...form, cuerpo: e.target.value })}
                        data-testid="anuncio-cuerpo" />
            </div>
            <div className="space-y-2">
              <Label>Categoría</Label>
              <select className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm"
                      value={form.categoria} onChange={(e) => setForm({ ...form, categoria: e.target.value })}
                      data-testid="anuncio-categoria">
                {["circular", "evento", "academico", "financiero"].map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <Button className="rounded-full py-6" onClick={crear} data-testid="guardar-anuncio">Publicar anuncio</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
